<template>
<div class="backgroud-white cs-courseSchedule-editor">
    <div class="text-center">
        <h4>{{title}}学期</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="termYear" label="学年" label-width="100px" class="label-strong">
                <el-select placeholder="请选择" v-model="form.Year" size="medium" class="popup-input-width-range-mini">
                    <el-option v-for="item in termYearList" :key="item.Value" :label="item.Text" :value="item.Value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="season" label="学季" label-width="100px" class="label-strong">
                <el-select placeholder="请选择" v-model="form.Season" size="medium" class="popup-input-width-range-mini">
                    <el-option v-for="item in termSeasonList" :key="item.Value" :label="item.Text" :value="item.Value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="name" label="学期名称" label-width="100px" class="label-strong">
                <el-input v-model="form.Name" placeholder="请输入内容" class="popup-input-width-range-mini"></el-input>
            </el-form-item>
            <el-form-item prop="preRecruiteDate" label="提前招生" label-width="100px" class="label-strong">
                <el-date-picker align="center" class="popup-input-width-small" format="yyyy/MM/dd" v-model="form.PreRecruiteDate" type="date" placeholder="选择提前招生日期"></el-date-picker>
            </el-form-item>
            <el-form-item prop="startDate" label="开始日期" label-width="100px" class="label-strong">
                <el-date-picker align="center" class="popup-input-width-small" format="yyyy/MM/dd" v-model="form.StartDate" type="date" placeholder="选择学期开始日期"></el-date-picker>
            </el-form-item>
            <el-form-item prop="endDate" label="结束日期" label-width="100px" class="label-strong">
                <el-date-picker align="center" class="popup-input-width-small" format="yyyy/MM/dd" v-model="form.EndDate" type="date" placeholder="选择学期结束日期"></el-date-picker>
            </el-form-item>
        </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
        <el-row>
            <el-col :span="20" :xs="16" class="footer-left">
                <span v-if="!showError"></span>
                <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
            </el-col>
            <el-col class="footer-right" :span="4" :xs="8">
                <el-button :loading="isSaving" type="primary" @click="save()">保存</el-button>
            </el-col>
        </el-row>
    </div>
</div>
</template>

<script>
import {
    getTermYearList,
    getTermSeasonList
} from "../../config/mUtils.js"
import {
    saveTerm
} from "../../service/termManage.service.js"
export default {
    props: ["mode", "editingForm", "currentTerm", "isVisible"],
    data() {
        var validateYear = (rule, value, callback) => {
            if (!this.form.Year) {
                callback(new Error("请选择学年"));
                return;
            }
            if (!this.form.Season) {
                callback();
                return;
            }
            if (this.mode == "add") {
                if (this.form.Year < this.currentTerm.Year) {
                    callback(new Error("新学期的学年不能小于当前学年"));
                    return;
                }
                if (this.form.Year == this.currentTerm.Year && this.form.Season <= this.currentTerm.Season) {
                    callback(new Error("同学年的新学期，学季不能小于当前学季"));
                    return;
                }
            }
            callback();
        }
        var validateSeason = (rule, value, callback) => {
            if (!this.form.Season) {
                callback(new Error("请选择学季"));
                return;
            }
            if (!this.form.Year) {
                callback();
                return;
            }
            if (this.mode == "add") {
                if (this.form.Year < this.currentTerm.Year) {
                    callback(new Error("新学期的学年不能小于当前学年"));
                    return;
                }
                if (this.form.Year == this.currentTerm.Year && this.form.Season <= this.currentTerm.Season) {
                    callback(new Error("同学年的新学期，学季不能小于当前学季"));
                    return;
                }
            }
            callback();
        }
        var validateName = (rule, value, callback) => {
            if (!this.form.Name) {
                callback();
                return;
            }
            let i = /^(?!_)([0-9A-Za-z ]+)$/;
            if (!this.form.Name.match(i)) {
                callback(new Error("名称只能输入英文和数字"));
                return;
            }
            callback();
        }
        var validatePreRecuitDate = (rule, value, callback) => {
            // if (!this.form.PreRecruiteDate) {
            //     callback(new Error("请输入提前招生日期"));
            //     return;
            // }
            if (!!this.form.PreRecruiteDate){
                let end = new Date(this.form.EndDate);
                let preRecruiteDate = new Date(this.form.PreRecruiteDate);
                if (preRecruiteDate >= end) {
                    callback(new Error("提前招生日期不能大于学期结束日期"));
                    return;
                }
            }
           
            callback();
        };
        var validateStartDate = (rule, value, callback) => {
            if (!this.form.StartDate) {
                callback(new Error("请输入学期开始日期"));
                return;
            }
            if (!this.form.EndDate) {
                callback();
                return;
            }
            let start = new Date(this.form.StartDate);
            let end = new Date(this.form.EndDate);
            if (start >= end) {
                callback(new Error("学期开始日期必须大于结束日期"));
                return;
            }
            callback();
        };
        var validateEndDate = (rule, value, callback) => {
            if (!this.form.EndDate) {
                callback(new Error("请输入学期结束日期"));
                return;
            }
            if (!this.form.StartDate) {
                callback();
                return;
            }
            let start = new Date(this.form.StartDate);
            let end = new Date(this.form.EndDate);
            if (start >= end) {
                callback(new Error("学期开始日期必须大于结束日期"));
                return;
            }

            callback();
        };
        return {
            title: this.mode == "edit" ? "编辑" : "添加",
            showError: false,
            errorMessage: "",
            termYearList: [],
            isSaving: false,
            termSeasonList: getTermSeasonList(),
            form: {
                Id: null,
                Year: "",
                Season: "",
                StartDate: "",
                EndDate: "",
                PreRecruiteDate: "",
                Name: ""
            },
            rules: {
                termYear: [{
                    required: true,
                    validator: validateYear,
                    trigger: 'change'
                }],
                season: [{
                    required: true,
                    validator: validateSeason,
                    trigger: 'change'
                }],
                name: [{
                    validator: validateName,
                    trigger: "blur"
                }],
                preRecruiteDate: [{
                    required: false,
                    validator: validatePreRecuitDate,
                    trigger: "blur"
                }],
                startDate: [{
                    required: true,
                    validator: validateStartDate,
                    trigger: "blur"
                }],
                endDate: [{
                    required: true,
                    validator: validateEndDate,
                    trigger: "blur"
                }],
            }
        };
    },
    created() {
        if (this.editingForm != null) {
            this.form = this.editingForm;
        }
        let years = getTermYearList();
        if (this.currentTerm) {
            years.forEach(element => {
                if (element.Value >= this.currentTerm.Year) {
                    this.termYearList.push(element);
                }
            });
        }
    },
    watch: {
        isVisible: function () {
            if (!this.isVisible) {
                this.newForm();
                this.$refs.form.resetFields();
            }
        },
        editingForm: function () {
            this.form = this.editingForm;
        }
    },
    methods: {
        checkAllInputs() {
            let isValid = true;
            this.$refs.form.validate(valid => {
                if (!valid) {
                    isValid = false;
                    return;
                }
                this.submitBtnClass = "primary";
                this.submitBtnDisable = false;
            });
            if (isValid) {
                this.submitBtnClass = "primary";
                this.submitBtnDisable = false;
            } else {
                this.submitBtnClass = "info";
                this.submitBtnDisable = true;
            }
        },
        newForm() {
            this.form = {
                Id: null,
                Year: null,
                Season: "",
                StartDate: "",
                EndDate: "",
                PreRecruiteDate: "",
                Name: ""
            };
        },
        close() { 
            this.$refs.form.resetFields();
            this.$emit("saveTermSuccess");
        },
        save() {
            this.errorMessage = "";
            this.showError = false;
            let valid = true;
            this.$refs.form.validate(v => {
                if (!v) {
                    valid = false;
                }
            });
            if (!valid) return;
            this.isSaving = true;
            saveTerm(this.form).then(result => {
                if (result) {
                    if (!result.success) {
                        this.errorMessage = result.message;
                        this.showError = true;
                    } else {
                        this.$message("保存成功");
                        this.close();
                    }
                }
                this.isSaving = false;
            })
        }
    },
    watch: {
        mode: function () {
            this.title = this.mode == "edit" ? "编辑" : "添加";
        },
        editingForm: function () {
            if (this.editingForm == null) {
                this.newForm();
            } else
                this.form = this.editingForm;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/termManagement/termEditor.vue